'use client'

import { UserProfile } from '@clerk/nextjs'

export const UserProfileSection = () => {
    return (
        <div className="w-full">
            <UserProfile
                routing="hash"
                appearance={{
                    variables: {
                        colorShadow: 'transparent',
                    },
                    elements: {
                        rootBox: 'w-full',
                        card: 'border-0 w-full',
                        navbar: 'hidden',
                        navbarMobileMenuButton: 'hidden',
                        scrollBox: 'p-0',
                        pageScrollBox: 'p-0',
                        page: 'p-0',
                    },
                }}
            />
        </div>
    )
}
